import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL — permanently redirects to keyword-first slug.
export const Route = createFileRoute("/fort-collins-web-design")({
  beforeLoad: () => {
    throw redirect({
      to: "/web-design-fort-collins-colorado",
      statusCode: 301,
    });
  },
});
